export default "__VITE_ASSET__z_RbFmSl__"